import loadable from '@loadable/component';

export const NotFound = loadable(() => import('../pages/errors/NotFound/NotFound'), {
  resolveComponent: (m) => m.NotFound,
});
